import Axios from "axios";
import { Message } from 'element-ui';

const axios = Axios.create({
    baseURL: "/api/",
});

export default {
    post(url, data, option) {
        return axios({
            method: "POST",
            url,
            data,
            ...option,
        }).then((res) => {
            const data = res.data;
            if (data) {
                if (data.code === 200) {
                    return data;
                }
                Message.error(data.message);
            }
            throw data;
        });
    },
    get(url, params, option) {
        return axios({
            url,
            params,
            ...option,
        }).then((res) => {
            const data = res.data;
            if (data) {
                if (data.code === 200) {
                    return data;
                }
                Message.error(data.message);
            }
            throw data;
        });
    },
    upload(url, data, option) {
        return axios({
            url,
            data,
            method: "POST",
            ...option,
        }).then((res) => {
            const data = res.data;
            if (data) {
                if (data.code === 200) {
                    return data;
                }
                Message.error(data.message);
            }
            throw data;
        });
    },
};
